
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'SalesNetwork',
  data() {
    return {
      baseUrl
    };
  },
  props: {
    second: {
      required: true,
      default: () => {
        return null;
      }
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleImgLoad(container, src) {
      if (container && src) {
        const img = new Image();
        img.src = src;
        const oriHeight = img.height;

        container.style.height = `${oriHeight}px`;
      }
    }
  }
});
